import React from "react";

const Description = () => {
  return (
    <div className="container my-5 main-content">
      <div className="heading">The CCBEL Group</div>
      <hr />
      <div className="textAlign">
        Our research team focuses on understanding the important interfacial
        phenomena and the development of new materials capable of water and
        ice-repellent properties and drug discovery. We investigate the
        microscopic structure, phase transitions, and dynamics of bulk, confined
        water, and fluid mixtures using a multiscale simulation approach from
        quantum to coarse- grained simulations. We further focus on machine
        learning methods for computational drug discovery and ML-based force
        field development.
      </div>
      <br />
      <h3 className="heading">Current Research Area</h3> <hr />
      <div>
        <ol>
          <li className="textAlign">
            Enhanced the Gas Hydrate Formation by Antifreeze Molecules:
            Applications in Gas Storage and Energy Recovery
          </li>
          <li className="textAlign">
            Multiscale Modelling and Machine Learning Approach for Rational
            Alzheimer’s Drug Design
          </li>
          <li className="textAlign">
            Ice Nucleation Mechanisms and Anti-Icing Activity of Organic
            Crystals and Biological Molecules
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Description;
